import React from "react";
import {useDispatch} from "react-redux";
import {editEntrantStatusAction} from "../../../../../../store/pages/admission/actions";
import {Modal, Typography} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {Trans, useTranslation} from "react-i18next";


export const AcceptModal = ({
                              visible,
                              setVisible,
                              initialVisibleState,
                              data
                            }: any) => {
  const dispatch = useDispatch();
  const {t} = useTranslation(["educationOrders", "common"])


  const handleClose = () => {
    setVisible(initialVisibleState)
  }

  const handleOk = () => {
    //ok actions
    setVisible(initialVisibleState)

    const requestData = {
      selected_speciality_id: data && data.selectedSpeciality && data.selectedSpeciality.id,
      response: "1"
    }
//@ts-ignore
    dispatch(editEntrantStatusAction(requestData))

  }

  return (
    <Modal
      open={visible}
      title={t("educationOrders:entrantConfirmation")}
      centered
      width={548}
      closable
      className="modal_container "
      closeIcon={<CloseOutlined style={{color: "#fff"}}/>}

      okText={t("common:confirm")}
      cancelText={t("common:cancel")}

      onOk={handleOk}
      onCancel={handleClose}
      rootClassName='modal-restore'
    >
      <div style={{width: '100%', padding: 56, textAlign: 'center'}}>
        <Typography.Text style={{textAlign: 'center'}}>
          <Trans i18nKey="educationOrders:acceptModalText"
                 values={{specialtyName: data && data.selectedSpeciality && data.selectedSpeciality.speciality && data.selectedSpeciality.speciality.caption}}>
            Абитуриент был уведомлен о том, что получил грант, и подтверждает поступление на специальность <span
            className="speciality-name">{data && data.selectedSpeciality && data.selectedSpeciality.speciality && data.selectedSpeciality.speciality.caption}</span>
          </Trans>
        </Typography.Text>
      </div>
    </Modal>
  );
}